// actions/feedbackActions.js
import createApi from "../utils/apiClient";
const api = createApi();

// Admin — అన్ని feedbacks తీసుకోవడం (filters optional)
export const getAllFeedbacks =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "ALL_FEEDBACKS_REQUEST" });
      const { data } = await api.get("/feedback", { params });
      dispatch({ type: "ALL_FEEDBACKS_SUCCESS", payload: data.feedbacks });
    } catch (err) {
      dispatch({
        type: "ALL_FEEDBACKS_FAIL",
        payload: err.response?.data?.message,
      });
    }
  };

// Logged-in user తన feedbacks చూసుకోవడానికి
export const getMyFeedbacks = () => async (dispatch) => {
  try {
    dispatch({ type: "MY_FEEDBACKS_REQUEST" });
    const { data } = await api.get("/feedback/my");
    dispatch({ type: "MY_FEEDBACKS_SUCCESS", payload: data.feedbacks });
  } catch (err) {
    dispatch({
      type: "MY_FEEDBACKS_FAIL",
      payload: err.response?.data?.message,
    });
  }
};

// Feedback submit చేయడం (ఏ role అయినా)
export const createFeedback = (feedbackData) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_FEEDBACK_REQUEST" });
    const { data } = await api.post("/feedback", feedbackData);
    dispatch({ type: "CREATE_FEEDBACK_SUCCESS", payload: data.feedback });
  } catch (err) {
    dispatch({
      type: "CREATE_FEEDBACK_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Admin — status / remarks update
export const updateFeedback = (id, updateData) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_FEEDBACK_REQUEST" });
    const { data } = await api.put(`/feedback/${id}`, updateData);
    dispatch({ type: "UPDATE_FEEDBACK_SUCCESS", payload: data.feedback });
  } catch (err) {
    dispatch({
      type: "UPDATE_FEEDBACK_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Admin — delete
export const deleteFeedback = (id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_FEEDBACK_REQUEST" });
    await api.delete(`/feedback/${id}`);
    dispatch({ type: "DELETE_FEEDBACK_SUCCESS", payload: id });
  } catch (err) {
    dispatch({
      type: "DELETE_FEEDBACK_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};
